import React from 'react';
import { remCalc } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { Fade } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { GuessStates, GuessImgSrcMap } from 'types';

const t = (key: string) => translate('activities', key);
interface Props {
  guessIndicator: string;
  SceneComponent: React.ReactChild;
  tileComponents: any[];
}

const GWhoRoundLayout: React.FC<Props> = ({ guessIndicator, SceneComponent, tileComponents }) => {
  const classes = styles();

  return (
    <div className={classes.container}>
      <div className={classes.tiles}>
        {tileComponents.map((TileComponent, index) => (
          <TileComponent key={index} />
        ))}
      </div>
      <div className={classes.scene}>
        {SceneComponent}
        <Fade in={guessIndicator !== GuessStates.NULL}>
          <img
            alt={t('feedbackImg')}
            className={classes.guessImg}
            src={GuessImgSrcMap[guessIndicator]}
          />
        </Fade>
      </div>
    </div>
  );
};

const styles = makeStyles(() => ({
  container: {
    height: '100%',
    maxWidth: remCalc(1200),
    margin: 'auto',
    display: 'flex',
    alignItems: 'stretch',
    gridGap: '1rem',
    padding: '0.5rem',
  },
  tiles: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: '1rem',
    justifyContent: 'stretch',
    alignItems: 'stretch',
    flex: '1',
  },
  scene: {
    flex: 2,
    position: 'relative',
  },
  guessImg: {
    position: 'absolute',
    top: `50%`,
    left: `50%`,
    transform: 'translate(-50%, -50%)',
  },
}));

export default GWhoRoundLayout;
